import { ScaleWall, StatWall } from "@/components/marketplace"
import type { ScaleWallSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const ScaleWallFeedSection = ({ section, context }: FeedSectionProps<ScaleWallSection>) => {
  const { count, sentence, images, cta, stats } = section.data

  return (
    <SectionFrame section={section} context={context} gut>
      {stats && stats.length > 0 ? (
        <StatWall stats={stats} />
      ) : (
        <ScaleWall count={count} sentence={sentence} images={images} cta={cta?.label} ctaHref={cta ? resolveFeedLink(cta.link, context.countryCode, context.page) : undefined} />
      )}
    </SectionFrame>
  )
}
